import { useEffect } from 'react';

import { HistoryRow } from 'components/HistoryRow/HistoryRow';

export const AdminCandidateHistoryTab = ({
  candidate,
  company,
  companyChecks,
  referees,
  historyData,
  fetchHistoryData,
}) => {
  useEffect(() => {
    if (candidate?.id) {
      fetchHistoryData();
    }
  }, [candidate?.id, fetchHistoryData]);

  return (
    <div className="u-padding">
      {(historyData || []).map(entry => (
        <HistoryRow
          key={entry?.id}
          entry={entry}
          company={company}
          companyChecks={companyChecks}
          candidate={candidate}
          referees={referees}
        />
      ))}
    </div>
  );
};
